export default [
  {
    path: '/user-stage',
    component: () => import('./views/Index'),
    name: 'user-stage',
    redirect: { name: 'user-stage-list' },
    children: [
      {
        path: '',
        name: 'user-stage-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
